<template>
  <b-container class="sign-in" fluid>
    <b-row class="h-100">
      <b-col cols="4" class="d-none d-md-block sign-in__bg" />
      <b-col
        sm="12"
        md="8"
        lg="6"
        class="d-flex flex-column justify-content-center align-items-stretch align-self-center"
      >
        <slot />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'NotLoggedInView'
};
</script>
